import React, { useState } from "react";
import UseTable from "../../components/table/useTable";
import { useTranslation } from "react-i18next";
import globalStyles from "../../style/global.js";
import useStyles from "./administratorsStyle";

import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";

import ErrorMessage from "../../components/errorMessage/ErrorMessage";
import CircularProgressBar from "../../components/circularProgress/CircularProgress";
import AddAdminDialog from "../../components/addAdminDialog/AddAdminDialog";
import { Box } from "@mui/material";
import Button from "../../components/controls/Button";
import PageTitle from "../../components/pageTitle/PageTitle";
import { getAdministratorsData } from "../../redux/reduser/administrators";
import EditAdminDialog from "../../components/editAdminDialog/EditAdminDialog";

function Administrators() {
    const { t } = useTranslation();
    const classes = useStyles();
    const globalClasses = globalStyles();
    const { data, loading, error } = useSelector((state) => state.administrators);
    const [openAddAdminDialog, setOpenAddAdminDialog] = useState(false);
    const [openEditAdminDialog, setOpenEditAdminDialog] = useState(false);
    const [index, setIndex] = useState(null);
    const handleClose = () => {
      setOpenAddAdminDialog(false);
    };
    const handleCloseEditAdminDialog = () => {
      setOpenEditAdminDialog(false);
    };
    const dispatch = useDispatch();
    useEffect(() => {
      dispatch(getAdministratorsData());
    }, []);
  
    const columns = [
      { name: t("id") },
      { name: t("userName") },
      { name: t("email") },
      { name: t("phone") },
      {
        name: t(""),
        options: {
          filter: false,
          sort: false,
          customBodyRenderLite: (dataIndex) => {
            return (
              <Button
                className={classes.btn}
                color="primary"
                disabled={false}
                onClick={() => {
                 setIndex(dataIndex);
                 setOpenEditAdminDialog(true);
                 
                }}
                text={t("edit")}
              />
            );
          },
        },
      },
    ];
  
    return (
      <Box className={globalClasses.background}>
      <Box className={globalClasses.page}>
      <Box className={globalClasses.row}>
       <PageTitle title={t("administrators")}/>
     
                 <Button
              className={classes.btn}
             
              variant="contained"
              color="primary"
              disabled={false}
              onClick={()=>{
           
                setOpenAddAdminDialog(true);
              }}
              type="submit"
              text={t("addAdministrator")}
            />
      </Box>
      <Box >
      <AddAdminDialog open={openAddAdminDialog} handleClose={handleClose} close={t("close")} 
       title={ t("addAdministrator")}  
      />
      <EditAdminDialog open={openEditAdminDialog} handleClose={handleCloseEditAdminDialog} close={t("close")} 
     title={ data!=[] && index!=null?data[index][1]:""}  data={data!=[]?data[index]:""}
      />
        {loading === true ? (
          <div className={globalClasses.center}>
            {" "}
            <CircularProgressBar />{" "}
          </div>
        ) : error == null ? (
          <UseTable
            data={data}
            columns={columns}
            title={t("administrators")}
            selectableRows={true}
            
          />
        ) : (
          <div className={globalClasses.center}>
            {" "}
            <ErrorMessage title={error} />{" "}
          </div>
        )}
      </Box>
      
      </Box>
      </Box>
    );
  }
export default Administrators
